import moment from 'moment';
import { auditLogTableColumns } from '../../constants/tableColumns';
import { useAuditLogContext } from '../../contexts/AuditLogProvider';
import useCheckUserFeaturePermissions from '../../hooks/useCheckUserFeaturePermissions';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';
import AlterAuditLogsAction from './AlterAuditLogsAction';

const ShowAllAuditLogs = () => {
  // integration of context hooks here
  const { auditLogList, isFetching, isLoading } = useAuditLogContext();

  // integration of custom hooks here
  const { featureBasedPermissions } =
    useCheckUserFeaturePermissions('auditLog');

  // rendering show all audit logs section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : featureBasedPermissions?.includes('READ') ? (
        <>
          <PageHeader headerText='Audit Logs' />

          <AcademiaTable
            data={auditLogList.map((log) => ({
              ...log,
              action_time: moment(log.action_time).format('DD-MM-YYYY'),
            }))}
            columns={auditLogTableColumns}
            tableToolbarComponent={<AlterAuditLogsAction />}
            notFoundMessage='No audit logs found!'
            isTableDataLoading={isFetching}
          />
        </>
      ) : (
        <AcademiaLoading />
      )}
    </section>
  );
};

export default ShowAllAuditLogs;
